import { Module } from 'vuex'

import { GetOpenReviewEntryListUseCase } from '@/application/review/getOpenReviewEntryListUseCase'
import { ReviewEntry } from '@/domain/entities/review/reviewEntry'
import { ReviewEntryRepository } from '@/domain/repositories/review/reviewEntryRepository'

interface ReviewEntryState {
  entryList: ReviewEntry[]
  isLoading: boolean
  error: Error | null
}

export const openReviewEntryModule = (reviewEntryRepository: ReviewEntryRepository): Module<ReviewEntryState, any> => {
  const getOpenReviewEntryListUseCase = new GetOpenReviewEntryListUseCase(reviewEntryRepository)

  return {
    namespaced: true,
    state: {
      entryList: [],
      isLoading: false,
      error: null
    },
    mutations: {
      setEntryList(state, entryList: ReviewEntry[]) {
        state.entryList = entryList
      },
      setLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },
    actions: {
      async fetchReviewEntryList({ state, commit }, { userId, problemId }: { userId: string; problemId: string }) {
        commit('setLoading', true)
        commit('setError', null)
        try {
          const entryList = await getOpenReviewEntryListUseCase.getByUserIdAndProblemIdOpenEntries(userId, problemId)
          commit('setEntryList', entryList)
        } catch (e) {
          commit('setError', e)
          commit('setEntryList', [])
        } finally {
          commit('setLoading', false)
        }
      }
    },
    getters: {
      entryList: state => state.entryList,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
